import React, { useState, useEffect } from "react";
import Header from "../components/header";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { apiurl } from "../config/config";
import { SuwasthiLoader } from "../components/loader";
import { User, Mail, Phone, Calendar, Heart, Droplet ,Briefcase, Users, CalendarDays, UserCheck } from "lucide-react";

const JoiningForm = () => {
  const [formData, setFormData] = useState({
    employeeCode: "",
    employeeId: "",
    personalDetails: {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      dateOfBirth: "",
      bloodGroup: "",
      maritalStatus: "",
      gender: "",
      permanentAddress: {
        type: "home",
        address1: "",
        address2: "",
        city: "",
        province: "",
        zipCode: "",
        country: "",
        provinceCode: "",
        countryCode: "",
      },
      currentAddress: {
        type: "home",
        address1: "",
        address2: "",
        city: "",
        province: "",
        zipCode: "",
        country: "",
        provinceCode: "",
        countryCode: "",
      },
    },
    bankDetails: {
      bankName: "",
      accountHolderName: "",
      confirmAccountNumber: "",
      accountNumber: "",
      ifscCode: "",
      branchName: "",
      accountType: "",
    },
    identification: {
      passportNumber: "",
      voterId: "",
      drivingLicense: "",
      aadharNumber: "",
      panNumber: "",
      uanNumber: "",
      esicNumber: "",
      gratuityNumber: "",
      shopsEstablishmentReg: "",
    },
    familyDetails: {
      fatherName: "",
      fatherOccupation: "",
      fatherPhone: "",
      motherName: "",
      motherOccupation: "",
      motherPhone: "",
      spouseName: "",
      spouseOccupation: "",
      spousePhone: "",
    },
    emergencyContactDetails: {
      emergencyContactName: "",
      emergencyContactRelationship: "",
      emergencyContactPhone: "",
      emergencyContactEmail: "",
      emergencyContactAddress: "",
    },
    department: "",
    reportingManagerName: "",
    designation: "",
    isPermanentSame: false,
  });

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const { employeeToken } = useParams();

  useEffect(() => {
    const fetchEmployeeData = async () => {
      if (!employeeToken) return;

      try {
        const { data } = await axios.post(
          `${apiurl}/api/employee/get-details/${employeeToken}`
        );
        if (data?.employee) {
          const fetched = data.employee;
          setFormData((prev) => ({
            ...prev,
            employeeId: fetched.employeeId || "",
            employeeCode: fetched.employeeCode || "",
            personalDetails: {
              firstName: fetched.personalDetails?.firstName || "",
              lastName: fetched.personalDetails?.lastName || "",
              phone: fetched.personalDetails?.phone || "",
              email: fetched.personalDetails?.email || "",
              maritalStatus: fetched.personalDetails?.maritalStatus || "",
              gender: fetched.personalDetails?.gender || "",
              dateOfBirth: fetched.personalDetails?.dateOfBirth || "",
              bloodGroup: fetched?.personalDetails?.bloodGroup || "",
              // permanentAddress: {
              //   type: fetched?.personalDetails?.permanentAddress.type || "home",
              //   address1:
              //     fetched?.personalDetails?.permanentAddress.address1 || "",
              //   address2:
              //     fetched?.personalDetails?.permanentAddress.address2 || "",
              //   city: fetched?.personalDetails?.permanentAddress.city || "",
              //   province:
              //     fetched?.personalDetails?.permanentAddress.province || "",
              //   zipCode:
              //     fetched?.personalDetails?.permanentAddress.zipCode || "",
              //   country:
              //     fetched?.personalDetails?.permanentAddress.country || "",
              //   provinceCode:
              //     fetched?.personalDetails?.permanentAddress.provinceCode || "",
              //   countryCode:
              //     fetched?.personalDetails?.permanentAddress.countryCode || "",
              // },
              // currentAddress: {
              //   type: fetched?.personalDetails?.currentAddress.type || "home",
              //   address1:
              //     fetched?.personalDetails?.currentAddress.address1 || "",
              //   address2:
              //     fetched?.personalDetails?.currentAddress.address2 || "",
              //   city: fetched?.personalDetails?.currentAddress.city || "",
              //   province:
              //     fetched?.personalDetails?.currentAddress.province || "",
              //   zipCode: fetched?.personalDetails?.currentAddress.zipCode || "",
              //   country: fetched?.personalDetails?.currentAddress.country || "",
              //   provinceCode:
              //     fetched?.personalDetails?.currentAddress.provinceCode || "",
              //   countryCode:
              //     fetched?.personalDetails?.currentAddress.countryCode || "",
              // },
              currentAddress: {
                ...prev.personalDetails.currentAddress,
                ...(fetched.personalDetails?.currentAddress || {}),
              },
              permanentAddress: {
                ...prev.personalDetails.permanentAddress,
                ...(fetched.personalDetails?.permanentAddress || {}),
              },
              isPermanentSame: fetched.isPermanentSame || false,
            },
            bankDetails: {
              bankName: fetched.bankDetails.bankName || "",
              accountHolderName: fetched.bankDetails.accountHolderName || "",
              accountNumber: fetched.bankDetails.accountNumber || "",
              confirmAccountNumber: fetched.bankDetails.accountNumber || "",
              ifscCode: fetched.bankDetails.ifscCode || "",
              branchName: fetched.bankDetails.branchName || "",
              accountType: fetched.bankDetails.accountType || "",
            },
            identification: {
              passportNumber: "",
              voterId: "",
              drivingLicense: "",
              aadharNumber: fetched?.identification?.aadharNumber || "",
              panNumber: fetched?.identification?.panNumber || "",
              uanNumber: "",
              esicNumber: "",
              gratuityNumber: "",
              shopsEstablishmentReg: "",
            },
            familyDetails: {
              fatherName: fetched.familyDetails.fatherName || "",
              fatherOccupation: fetched.familyDetails.fatherOccupation || "",
              fatherPhone: fetched.familyDetails.fatherPhone || "",
              motherName: fetched.familyDetails.motherName || "",
              motherOccupation: fetched.familyDetails.motherOccupation || "",
              motherPhone: fetched.familyDetails.motherPhone || "",
              spouseName: fetched.familyDetails.spouseName || "",
              spouseOccupation: fetched.familyDetails.spouseOccupation || "",
              spousePhone: fetched.familyDetails.spousePhone || "",
            },
            emergencyContactDetails: {
              emergencyContactName:
                fetched?.emergencyContactDetails?.emergencyContactName || "",
              emergencyContactRelationship:
                fetched?.emergencyContactDetails
                  ?.emergencyContactRelationship || "",
              emergencyContactPhone:
                fetched?.emergencyContactDetails?.emergencyContactPhone || "",
              emergencyContactEmail:
                fetched?.emergencyContactDetails?.emergencyContactEmail || "",
              emergencyContactAddress:
                fetched?.emergencyContactDetails?.emergencyContactAddress || "",
            },
            reportingDetails: {
              managerName: fetched.reportingDetails.managerName || "",
            },
            department: fetched.department || "",
            designation: fetched.designation || "",
            employeeJoiningDate: fetched.employeeJoiningDate || "",
            reportingManagerName: fetched.reportingManagerName || "",
            isPermanentSame: fetched.isPermanentSame || false,
          }));
        }
      } catch (err) {
        console.error("Error fetching employee:", err);
        alert("Invalid or expired link.");
      }
    };

    fetchEmployeeData();
  }, [employeeToken]);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   if (["firstName", "lastName"].includes(name)) {
  //     setFormData((prev) => ({
  //       ...prev,
  //       personalDetails: { ...prev.personalDetails, [name]: value },
  //     }));
  //   } else {
  //     setFormData((prev) => ({ ...prev, [name]: value }));
  //   }

  //   if (name === "confirmAccountNumber" || name === "accountNumber") {
  //     setErrors((prev) => ({
  //       ...prev,
  //       accountMismatch:
  //         name === "confirmAccountNumber" && value !== formData.accountNumber,
  //     }));
  //   }
  // };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   if (
  //     [
  //       "firstName",
  //       "lastName",
  //       "email",
  //       "phone",
  //       "dateOfBirth",
  //       "bloodGroup",
  //       "gender",
  //       "maritalStatus",
  //     ].includes(name)
  //   ) {
  //     setFormData((prev) => ({
  //       ...prev,
  //       personalDetails: { ...prev.personalDetails, [name]: value },
  //     }));
  //   } else {
  //     setFormData((prev) => ({ ...prev, [name]: value }));
  //   }

  //   if (
  //     [
  //       "aadharNumber",
  //       "drivingLicense",
  //       "esicNumber",
  //       "gratuityNumber",
  //       "panNumber",
  //       "passportNumber",
  //       "shopsEstablishmentReg",
  //       "uanNumber",
  //       "voterId",
  //     ].includes(name)
  //   ) {
  //     setFormData((prev) => ({
  //       ...prev,
  //       identification: { ...prev.identification, [name]: value },
  //     }));
  //   } else {
  //     setFormData((prev) => ({ ...prev, [name]: value }));
  //   }

  //   if (
  //     [
  //       "bankName",
  //       "accountHolderName",
  //       "confirmAccountNumber",
  //       "accountNumber",
  //       "ifscCode",
  //       "branchName",
  //       "accountType",
  //     ].includes(name)
  //   ) {
  //     setFormData((prev) => ({
  //       ...prev,
  //       bankDetails: { ...prev.bankDetails, [name]: value },
  //     }));
  //   } else {
  //     setFormData((prev) => ({ ...prev, [name]: value }));
  //   }

  //   if (
  //     [
  //       "emergencyContactName",
  //       "emergencyContactRelationship",
  //       "emergencyContactPhone",
  //       "emergencyContactEmail",
  //       "emergencyContactAddress",
  //     ].includes(name)
  //   ) {
  //     setFormData((prev) => ({
  //       ...prev,
  //       emergencyContactDetails: {
  //         ...prev.emergencyContactDetails,
  //         [name]: value,
  //       },
  //     }));
  //   } else {
  //     setFormData((prev) => ({ ...prev, [name]: value }));
  //   }

  //   if (name === "confirmAccountNumber" || name === "accountNumber") {
  //     setErrors((prev) => ({
  //       ...prev,
  //       accountMismatch:
  //         name === "confirmAccountNumber" && value !== formData.accountNumber,
  //     }));
  //   }
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;

    const fieldMapping = {
      personalDetails: [
        "firstName",
        "lastName",
        "email",
        "phone",
        "dateOfBirth",
        "bloodGroup",
        "gender",
        "maritalStatus",
      ],
      identification: [
        "aadharNumber",
        "drivingLicense",
        "esicNumber",
        "gratuityNumber",
        "panNumber",
        "passportNumber",
        "shopsEstablishmentReg",
        "uanNumber",
        "voterId",
      ],
      bankDetails: [
        "bankName",
        "accountHolderName",
        "confirmAccountNumber",
        "accountNumber",
        "ifscCode",
        "branchName",
        "accountType",
      ],
      emergencyContactDetails: [
        "emergencyContactName",
        "emergencyContactRelationship",
        "emergencyContactPhone",
        "emergencyContactEmail",
        "emergencyContactAddress",
      ],
      familyDetails: [
        "fatherName",
        "fatherOccupation",
        "fatherPhone",
        "motherName",
        "motherOccupation",
        "motherPhone",
        "spouseName",
        "spouseOccupation",
        "spousePhone",
        "dependents",
      ],
    };

    let updated = false;

    for (const section in fieldMapping) {
      if (fieldMapping[section].includes(name)) {
        setFormData((prev) => ({
          ...prev,
          [section]: {
            ...prev[section],
            [name]: value,
          },
        }));
        updated = true;
        break;
      }
    }

    // If not matched, update top-level fields
    if (!updated) {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    // Special Case for Account Number Match Validation
    if (["confirmAccountNumber", "accountNumber"].includes(name)) {
      setErrors((prev) => ({
        ...prev,
        accountMismatch:
          name === "confirmAccountNumber" && value !== formData.accountNumber,
      }));
    }
  };

  // const handleAddressChange = (type, field, value) => {
  //   setFormData((prev) => ({
  //     ...prev,
  //     personalDetails: {
  //       ...prev.personalDetails,
  //       [type]: {
  //         ...prev.personalDetails[type],
  //         [field]: value,
  //       },
  //     },
  //   }));
  // };
  const handleAddressChange = (addressType, field, value) => {
    setFormData((prev) => ({
      ...prev,
      personalDetails: {
        ...prev.personalDetails,
        [addressType]: {
          ...prev.personalDetails[addressType],
          [field]: value, // Update specific address field
        },
      },
    }));
  };

  const handleSameAsCurrent = () => {
    setFormData((prev) => ({
      ...prev,
      isPermanentSame: !prev.isPermanentSame,
      personalDetails: {
        ...prev.personalDetails,
        permanentAddress: prev.isPermanentSame
          ? {
              ...prev.personalDetails.permanentAddress,
              address1: "",
              address2: "",
              city: "",
              province: "",
              country: "",
              zipCode: "",
              landmark: "",
            }
          : prev.personalDetails.currentAddress, // Copy current address when checked
      },
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        `${apiurl}/api/employee/updateEmployeeDetailsByToken/${employeeToken}`,
        formData
      );
      alert("Employee registered successfully!");
      navigate(`/employees/joining-form/${employeeToken}/upload-documents`);
    } catch (error) {
      console.error("Submit failed:", error);
      alert("Submission failed. Try again.");
    }
  };

  console.log("Form Data:", formData);
  return (
    <>
      <Header title="Employee Registration" />

      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-2 py-4">
        <form
          onSubmit={handleSubmit}
          className="bg-white px-3 py-5 md:px-8 md:py-10 rounded-2xl shadow-xl w-full max-w-3xl border border-[#39160d]"
        >
          <h2 className="text-3xl font-bold mb-6 text-center">
            Employee Registration
          </h2>

          <div className="bg-gradient-to-br from-white to-gray-50 shadow-sm rounded-2xl p-4 border border-gray-200">
            {/* Header */}
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
                <User className="w-5 h-5 text-blue-500" />
                Personal Details
              </h2>
              <span className="px-3 py-1 text-xs font-medium bg-blue-100 text-blue-600 rounded-full">
                Verified
              </span>
            </div>

            {/* Grid Info */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm">
              {/* First Name */}
              <div className="p-3 bg-white rounded-xl shadow-sm border border-gray-100">
                <p className="text-gray-500 flex items-center gap-2">
                  <User className="w-4 h-4 text-gray-400" /> First Name
                </p>
                <p className="font-semibold text-gray-800 mt-1">
                  {formData.personalDetails.firstName || "-"}
                </p>
              </div>

              {/* Last Name */}
              <div className="p-3 bg-white rounded-xl shadow-sm border border-gray-100">
                <p className="text-gray-500">Last Name</p>
                <p className="font-semibold text-gray-800 mt-1">
                  {formData.personalDetails.lastName || "-"}
                </p>
              </div>

              {/* Email */}
              <div className="p-3 bg-white rounded-xl shadow-sm border border-gray-100">
                <p className="text-gray-500 flex items-center gap-2">
                  <Mail className="w-4 h-4 text-gray-400" /> Email
                </p>
                <p className="font-semibold text-gray-800 mt-1">
                  {formData.personalDetails.email || "-"}
                </p>
              </div>

              {/* Phone */}
              <div className="p-3 bg-white rounded-xl shadow-sm border border-gray-100">
                <p className="text-gray-500 flex items-center gap-2">
                  <Phone className="w-4 h-4 text-gray-400" /> Phone
                </p>
                <p className="font-semibold text-gray-800 mt-1">
                  {formData.personalDetails.phone || "-"}
                </p>
              </div>

              {/* Birth Date */}
              <div className="p-3 bg-white rounded-xl shadow-sm border border-gray-100">
                <p className="text-gray-500 flex items-center gap-2">
                  <Calendar className="w-4 h-4 text-gray-400" /> Birth Date
                </p>
                <p className="font-semibold text-gray-800 mt-1">
                  {formData.personalDetails.dateOfBirth || "-"}
                </p>
              </div>

              {/* Gender */}
              <div className="p-3 bg-white rounded-xl shadow-sm border border-gray-100">
                <p className="text-gray-500">Gender</p>
                <p className="font-semibold text-gray-800 mt-1">
                  {formData.personalDetails.gender || "-"}
                </p>
              </div>

              {/* Marital Status */}
              {/* <div className="p-3 bg-white rounded-xl shadow-sm border border-gray-100">
                <p className="text-gray-500 flex items-center gap-2">
                  <Heart className="w-4 h-4 text-gray-400" /> Marital Status
                </p>
                <p className="font-semibold text-gray-800 mt-1">
                  {formData.personalDetails.maritalStatus || "-"}
                </p>
              </div> */}

              {/* Blood Group */}
              {/* <div className="p-3 bg-white rounded-xl shadow-sm border border-gray-100">
                <p className="text-gray-500 flex items-center gap-2">
                  <Droplet className="w-4 h-4 text-red-400" /> Blood Group
                </p>
                <p className="font-semibold text-gray-800 mt-1">
                  {formData.personalDetails.bloodGroup || "-"}
                </p>
              </div> */}
            </div>
          </div>


          <div className="bg-gradient-to-br from-white to-gray-50 shadow-sm rounded-2xl p-6 border border-gray-200 mt-10">
  {/* Header */}
  <div className="flex items-center justify-between mb-6">
    <h2 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
      <Briefcase className="w-5 h-5 text-indigo-500" />
      Job Details
    </h2>
    <span className="px-3 py-1 text-xs font-medium bg-indigo-100 text-indigo-600 rounded-full">
      Active
    </span>
  </div>

  {/* Grid Info */}
  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm">
    {/* Department */}
    <div className="p-3 bg-white rounded-xl shadow-sm border border-gray-100">
      <p className="text-gray-500 flex items-center gap-2">
        <Users className="w-4 h-4 text-gray-400" /> Department
      </p>
      <p className="font-semibold text-gray-800 mt-1">
        {formData.department || "-"}
      </p>
    </div>

    {/* Designation */}
    <div className="p-3 bg-white rounded-xl shadow-sm border border-gray-100">
      <p className="text-gray-500 flex items-center gap-2">
        <Briefcase className="w-4 h-4 text-gray-400" /> Designation
      </p>
      <p className="font-semibold text-gray-800 mt-1">
        {formData.designation || "-"}
      </p>
    </div>

    {/* Date Of Joining */}
    <div className="p-3 bg-white rounded-xl shadow-sm border border-gray-100">
      <p className="text-gray-500 flex items-center gap-2">
        <CalendarDays className="w-4 h-4 text-gray-400" /> Date Of Joining
      </p>
      <p className="font-semibold text-gray-800 mt-1">
        {formData.employeeJoiningDate || "-"}
      </p>
    </div>

    {/* Reporting Manager */}
    <div className="p-3 bg-white rounded-xl shadow-sm border border-gray-100">
      <p className="text-gray-500 flex items-center gap-2">
        <UserCheck className="w-4 h-4 text-gray-400" /> Reporting Manager
      </p>
      <p className="font-semibold text-gray-800 mt-1">
        {formData.reportingManagerName || "-"}
      </p>
    </div>
  </div>
</div>

          {/* Basic Details */}
          {/* <h3 className="text-md font-semibold mb-4 mt-10 text-center border-4 border-double py-1">
            Basic Details
          </h3> */}
          {/* do not remove this code */}
          {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <InputField
              label="First Name"
              name="firstName"
              value={formData.personalDetails.firstName}
              onChange={handleChange}
            />
            <InputField
              label="Last Name"
              name="lastName"
              value={formData.personalDetails.lastName}
              onChange={handleChange}
            />
            <InputField
              label="Email"
              name="email"
              value={formData.personalDetails.email}
              onChange={handleChange}
              type="email"
            />
            <InputField
              label="Phone"
              name="phone"
              value={formData.personalDetails.phone}
              onChange={handleChange}
              type="tel"
            />
            <InputField
              label="Birth Date"
              name="dateOfBirth"
              value={formData.personalDetails.dateOfBirth}
              onChange={handleChange}
              type="date"
            />

            <div>
              <label className="block mb-2 text-sm font-medium text-gray-700">
                Gender
              </label>
              <select
                name="gender"
                value={formData.personalDetails.gender}
                onChange={handleChange}
                className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Select Status</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">other</option>
              </select>
            </div>

            <div>
              <label className="block mb-2 text-sm font-medium text-gray-700">
                Marital Status
              </label>
              <select
                name="maritalStatus"
                value={formData.personalDetails.maritalStatus}
                onChange={handleChange}
                className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Select Status</option>
                <option value="unmarried">Unmarried</option>
                <option value="married">Married</option>
                <option value="widowed">Widowed</option>
                <option value="divorced">Divorced</option>
              </select>
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-600 mb-1">
                Blood Group
              </label>
              <select
                name="bloodGroup"
                value={formData?.personalDetails?.bloodGroup}
                onChange={handleChange}
                className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Select Blood Group</option>
                <option value="A+">A+</option>
                <option value="A-">A-</option>
                <option value="B+">B+</option>
                <option value="B-">B-</option>
                <option value="O+">O+</option>
                <option value="O-">O-</option>
                <option value="AB+">AB+</option>
                <option value="AB-">AB-</option>
                <option value="Unknown">Unknown</option>
              </select>
            </div>
          </div> */}

          {/* Identification & Address */}
          <h3 className="text-md font-semibold mb-4 mt-10 text-center border-4 border-double py-1">
            Identification Details
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <InputField
              label="Aadhar Card"
              name="aadharNumber"
              value={formData.identification.aadharNumber}
              onChange={handleChange}
            />
            <InputField
              label="PAN Card"
              name="panNumber"
              value={formData.identification.panNumber}
              onChange={handleChange}
            />

            <div>
              <label className="block mb-2 text-sm font-medium text-gray-700">
                Marital Status
              </label>
              <select
                name="maritalStatus"
                value={formData.personalDetails.maritalStatus}
                onChange={handleChange}
                className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Select Status</option>
                <option value="unmarried">Unmarried</option>
                <option value="married">Married</option>
                <option value="widowed">Widowed</option>
                <option value="divorced">Divorced</option>
              </select>
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-600 mb-1">
                Blood Group
              </label>
              <select
                name="bloodGroup"
                value={formData?.personalDetails?.bloodGroup}
                onChange={handleChange}
                className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Select Blood Group</option>
                <option value="A+">A+</option>
                <option value="A-">A-</option>
                <option value="B+">B+</option>
                <option value="B-">B-</option>
                <option value="O+">O+</option>
                <option value="O-">O-</option>
                <option value="AB+">AB+</option>
                <option value="AB-">AB-</option>
                <option value="Unknown">Unknown</option>
              </select>
            </div>
          </div>

          <h3 className="text-md font-semibold mb-4 mt-10 text-center border-4 border-double py-1">
            Address Details
          </h3>

          <h4 className="font-bold mb-2">Current Address</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <select
              value={formData.personalDetails?.currentAddress?.type || "home"} // Default to 'home'
              onChange={(e) =>
                handleAddressChange("currentAddress", "type", e.target.value)
              }
              className="w-full p-3 border rounded-xl mb-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="home">Home</option>
              <option value="office">Office</option>
              <option value="other">Other</option>
            </select>
            {[
              "address1",
              "address2",
              "city",
              "province",
              "country",
              "zipCode",
              "landmark",
            ].map((field) => (
              <input
                key={field}
                placeholder={field.charAt(0).toUpperCase() + field.slice(1)}
                value={formData.personalDetails.currentAddress[field]}
                onChange={(e) =>
                  handleAddressChange("currentAddress", field, e.target.value)
                }
                className="w-full p-3 border rounded-xl mb-2"
              />
            ))}
          </div>

          {/* Permanent Address with Checkbox */}

          <div>
            <h4 className="font-bold mb-2 flex justify-between items-center">
              Permanent Address
            </h4>

            <label className="flex items-center mb-3">
              <input
                type="checkbox"
                checked={formData.isPermanentSame}
                onChange={handleSameAsCurrent}
                className="mr-2"
              />
              Same as Current Address
            </label>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <select
              value={formData.personalDetails.permanentAddress.type || "home"} // Default to 'home'
              onChange={(e) =>
                handleAddressChange("permanentAddress", "type", e.target.value)
              }
              disabled={formData.isPermanentSame}
              className="w-full p-3 border rounded-xl mb-2 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
            >
              <option value="home">Home</option>
              <option value="office">Office</option>
              <option value="other">Other</option>
            </select>

            {[
              "address1",
              "address2",
              "city",
              "province",
              "country",
              "zipCode",
              "landmark",
            ].map((field) => (
              <input
                key={field}
                placeholder={field.charAt(0).toUpperCase() + field.slice(1)}
                value={formData.personalDetails.permanentAddress[field]}
                onChange={(e) =>
                  handleAddressChange("permanentAddress", field, e.target.value)
                }
                className="w-full p-3 border rounded-xl mb-2"
                disabled={formData.isPermanentSame}
              />
            ))}
          </div>




          {/* Job Details */}
          {/* <h3 className="text-md font-semibold mb-4 mt-10 text-center border-4 border-double py-1">
            Job Details
          </h3> */}
          {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <InputField
              label="Department"
              name="department"
              value={formData.department}
              onChange={handleChange}
              readOnly={true}
            />
            <InputField
              label="Designation"
              name="designation"
              value={formData.designation}
              onChange={handleChange}
              readOnly={true}
            />
            <InputField
              label="Date Of Joining"
              name="employeeJoiningDate"
              type="input"
              readOnly={true}
              value={formData.employeeJoiningDate}
              onChange={handleChange}
            />
            <InputField
              label="Reporting Manager"
              name="reportingManager"
              readOnly={true}
              value={formData.reportingManagerName}
              onChange={handleChange}
            />
          </div> */}

          {/* Family Details */}
          <h3 className="text-md font-semibold mb-4 mt-10 text-center border-4 border-double py-1">
            Family Details
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <InputField
              label="Father's Name"
              name="fatherName"
              value={formData.familyDetails.fatherName}
              onChange={handleChange}
            />
            <InputField
              label="Father's Occupation"
              name="fatherOccupation"
              value={formData.familyDetails.fatherOccupation}
              onChange={handleChange}
            />
            <InputField
              label="Father's Phone"
              name="fatherPhone"
              value={formData.familyDetails.fatherPhone}
              onChange={handleChange}
            />
            <InputField
              label="Spouse Name"
              name="spouseName"
              value={formData.familyDetails.spouseName}
              onChange={handleChange}
            />
          </div>

          {/* Emergency Contact */}
          <h3 className="text-md font-semibold mb-4 mt-10 text-center border-4 border-double py-1">
            Emergency Contact Details
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <InputField
              label="Emergency Contact Name"
              name="emergencyContactName"
              value={formData.emergencyContactDetails.emergencyContactName}
              onChange={handleChange}
            />
            {/* <InputField
              label="Relationship"
              name="emergencyContactRelationship"
              value={formData.emergencyContactRelationship}
              onChange={handleChange}
            /> */}
            <div>
              <label className="block mb-2 text-sm font-medium text-gray-700">
                Relationship
              </label>
              <select
                name="emergencyContactRelationship"
                value={
                  formData.emergencyContactDetails.emergencyContactRelationship
                }
                onChange={handleChange}
                className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              >
                <option value="">Select Relationship</option>
                <option value="father">Father</option>
                <option value="mother">Mother</option>
                <option value="spouse">Spouse</option>
                <option value="brother">Brother</option>
                <option value="sister">Sister</option>
                <option value="friend">Friend</option>
                <option value="other">Other</option>
              </select>
            </div>
            <InputField
              label="Emergency Contact Phone"
              name="emergencyContactPhone"
              value={formData.emergencyContactDetails.emergencyContactPhone}
              onChange={handleChange}
            />
            <InputField
              label="Emergency Contact Address"
              name="emergencyContactAddress"
              value={formData.emergencyContactDetails.emergencyContactAddress}
              onChange={handleChange}
            />
          </div>

          <h3 className="text-md font-semibold mb-4 mt-10 text-center border-4 border-double py-1">
            Bank Details
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <InputField
              label="Bank Name"
              name="bankName"
              placeholder="Bank Name"
              value={formData.bankDetails.bankName}
              onChange={handleChange}
            />

            <InputField
              label="Account Holder Name"
              name="accountHolderName"
              placeholder="Account Holder Name"
              value={formData.bankDetails.accountHolderName}
              onChange={handleChange}
            />

            <InputField
              label="Account Number"
              name="accountNumber"
              placeholder="Account Number"
              value={formData.bankDetails.accountNumber}
              onChange={handleChange}
            />

            <InputField
              label="Confirm Account Number"
              name="confirmAccountNumber"
              placeholder="Confirm Account Number"
              value={formData.bankDetails.confirmAccountNumber}
              onChange={handleChange}
            />

            <InputField
              label="IFSC Code"
              name="ifscCode"
              placeholder="IFSC Code"
              value={formData.bankDetails.ifscCode}
              onChange={handleChange}
            />

            <InputField
              label="Branch Name"
              name="branchName"
              placeholder="Branch Name"
              value={formData.bankDetails.branchName}
              onChange={handleChange}
            />
          </div>
          {errors.accountMismatch && (
            <div className="text-red-500 col-span-2 text-sm">
              Account Number and Confirm Account Number do not match!
            </div>
          )}

          <button
            type="submit"
            className="bg-blue-600 text-white mt-10 font-semibold py-3 px-6 rounded-2xl w-full hover:bg-blue-700 transition"
          >
            Save & Continue
          </button>
        </form>
      </div>
    </>
  );
};

const InputField = ({
  label,
  name,
  value,
  onChange,
  type = "text",
  placeholder,
  readOnly = false,
}) => (
  <div>
    <label
      htmlFor={name}
      className="block text-sm font-medium text-gray-600 mb-1"
    >
      {label}
    </label>
    <input
      readOnly={readOnly}
      type={type}
      id={name}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
    />
  </div>
);

export default JoiningForm;
